import { Badge } from "~/components/ui/badge"
import type { JobDetail } from "~/components/company/job_listings/mock-data"

type Props = {
  job: JobDetail
}

export function JobDetailContent({ job }: Props) {
  return (
    <div className="lg:col-span-2 space-y-8">
      <div>
        <h2 className="text-xl font-bold text-gray-900 mb-4">About the Role</h2>
        <p className="text-gray-600 leading-relaxed">{job.description}</p>
      </div>

      <div>
        <h2 className="text-xl font-bold text-gray-900 mb-4">Responsibilities</h2>
        <ul className="list-disc list-inside space-y-2 text-gray-600">
          {job.responsibilities.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>

      <div>
        <h2 className="text-xl font-bold text-gray-900 mb-4">Requirements</h2>
        <ul className="list-disc list-inside space-y-2 text-gray-600">
          {job.requirements.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>

      <div>
        <h2 className="text-xl font-bold text-gray-900 mb-4">Nice to Have</h2>
        <div className="flex flex-wrap gap-2">
          {job.niceToHave.map((item, index) => (
            <Badge key={index} variant="outline">
              {item}
            </Badge>
          ))}
        </div>
      </div>
    </div>
  )
}
